import { Proposer } from '../../../domain'
import { InputConfig } from '../../../state/configuration'

export const toPolicyholderData = (policyholder: Proposer) => (input: InputConfig) =>
  policyholder[input.name]
